module.exports = __webpack_public_path__ + "assets/images/pages/ebaysocial/ebaysocial-3.png?4cdc9473";